



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { format } from 'date-fns';
import { ordersService } from '@/services';
import { Request, Users } from './types';

import { DatePicker } from '@/components/form';
import Button from '@/components/ext/Button.vue';
import { Select, Input, Checkbox as FormCheckBox } from '@/components/form';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import { formDataInputs } from '@/tools/formdatainputs';

const isNull = (value: null | Date) => value === null;

@Component({
  components: {
    AppButtonNew,
    DatePicker,
    Button,
    Select,
    Input,
    FormCheckBox,
  },
})
export default class RequestForm extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly users!: Users;

  @Prop({ type: Function })
  readonly closeModal: any;

  @Prop({ type: Function })
  readonly nextStep!: Function;

  @Prop({ type: Object, default: null })
  readonly file: Object;

  @Prop({ type: String, default: '' })
  readonly answer: string;

  @Prop({ type: Object, default: null })
  readonly errors!: any;

  today: Date = new Date();
  event_id: string = this.$store.state.event_card?.id || null;
  groups: Array<{}> = [];
  groupsDatesList = [];
  request: Request = {
    selectedGroupId: null,
    partner_id: null,
    is_partner_exists: false,
    dateStudyFrom: null,
    dateStudyTo: null,
    studentId: this.$store.state.user.profile.id,
    eduLevel: null,
    organization_name: null,
  };

  get isDisabled() {
    const {
      dateStudyFrom,
      dateStudyTo,
      eduLevel,
      organization_name,
      partner_id,
      is_partner_exists,
    } = this.request;
    return (
      (this.groupsDatesList.length > 0 && !eduLevel) ||
      (!organization_name && !is_partner_exists) ||
      (!partner_id && is_partner_exists) ||
      !(isNull(dateStudyFrom) === isNull(dateStudyTo))
    );
  }
  get getOrganizations() {
    return [
      ...this.$store.state.organizationsDict.map((el: any) => {
        return { value: el.id, text: el.name };
      }),
    ];
  }

  get eventOrderEduLevelsDict() {
    return this.$store.state.eventOrderEduLevelsDict.map((el: any) => ({
      value: el.id,
      text: el.name,
    }));
  }

  async getGroupsByEvent(id) {
    try {
      const {
        data: { data: groups },
      } = await this.$axiosInstance.get(
        `event/${id}/groups?limit=100&actual_schedule=1`
      );
      return groups;
    } catch (ex) {
      console.error('Error getting program groups: ', ex);
      return [];
    }
  }

  async created() {
    this.groups = await this.getGroupsByEvent(this.event_id);
    if (!this.groups.length) return;
    this.groupsDatesList =
      this.groups
        ?.filter((elem: any) => {
          return elem.schedule_date_from && elem.schedule_date_to;
        })
        .map((elem: any) => ({
          value: elem.group_id,
          text: `${elem.schedule_date_from?.split(' ')[0]} - ${
            elem.schedule_date_to?.split(' ')[0]
          } (${elem.group_name})`,
        })) || [];
  }

  async submitRequest() {
    const dateFrom =
      this.groups.find((el) => el.group_id === this.request.selectedGroupId)
        ?.schedule_date_from || null;
    const dateTo =
      this.groups.find((el) => el.group_id === this.request.selectedGroupId)
        ?.schedule_date_to || null;

    const tempValue = {
      ...this.request,
      is_partner_exists: this.request.is_partner_exists ? 1 : 0,
      date_study_from:
        dateFrom && dateTo ? format(dateFrom, 'YYYY-MM-DD') : null,
      date_study_to: dateTo && dateTo ? format(dateTo, 'YYYY-MM-DD') : null,
      'students[0][id]': this.request.studentId,
      'students[0][edu_level]': this.request.eduLevel,
      file: this.file || undefined,
      answer: this.answer || undefined,
      event_id: this.event_id,
    };
    if (this.request.is_partner_exists) {
      tempValue.organization_name = undefined;
    } else {
      tempValue.partner_id = undefined;
    }
    const formData = formDataInputs(tempValue);
    try {
      await ordersService(this.$axiosInstance).postOrderRequest2(formData);

      this.$emit('sendResult', {
        type: 'success',
      });
    } catch (err) {
      if (err.response.data) {
        const { errors } = err.response.data;
        let firstErrorMsg = null;
        const errorsArr = Array.isArray(errors)
          ? errors
          : Object.values(errors);
        if (errorsArr.length && errorsArr[0].errors) {
          firstErrorMsg = errorsArr[0].errors[0] || null;
        }

        this.$emit('sendResult', {
          type: 'error',
          text: {
            ...(firstErrorMsg &&
              firstErrorMsg.msg && { description: firstErrorMsg.msg }),
          },
        });
      }
    }
    this.nextStep();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ordersProcessForms/event/components/RequestForm.vue